import {
  parseTime
} from '@/utils/util'

export const searchForm = {
  name: '',
  type_id: undefined
}

export const rules = {
  name: [{
    required: true,
    message: '请输入违禁词',
    trigger: 'change'
  }],
  type_id: [{
    required: true,
    message: '请选择分类',
    trigger: 'change'
  }],
}

export const columns = [{
    title: '序号',
    align: 'center',
    width: 160,
    dataIndex: 'id'
  },
  {
    title: '违禁词分类',
    align: 'left',
    width: 240,
    dataIndex: 'type_id',
    scopedSlots: {
      customRender: 'type_id'
    }
  },
  {
    title: '归属模块',
    align: 'left',
    dataIndex: 'forbiddenWordsType.module_select',
    width: 340,
    scopedSlots: {
      customRender: 'module_select'
    }
  },
  {
    title: '违禁词',
    align: 'left',
    width: 300,
    dataIndex: 'name'
  },
  {
    title: '创建时间',
    align: 'left',
    dataIndex: 'created_at',
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '更新时间',
    align: 'left',
    dataIndex: 'updated_at',
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    align: 'center',
    width: 200,
    dataIndex: 'operator',
    scopedSlots: {
      customRender: 'operator'
    }
  }
]
